/*
 *   File : input.js
 *   Author : https://evoqins.com
 *   Description : Text input component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo } from "react";
import Icon from "../icons";
import { CustomTooltip } from "../Other";
import { formatInputErrorMessage } from "../../Utils/format-input-error";

const Input = (props) => {
  //input handle change
  const _handleChange = (e) => {
    props.handleChange(e.target.value);
  };

  // handle enter key press (guard: optional handler; defaultProps unreliable on memo in newer React)
  const _keyPress = (e) => {
    if (e.key === "Enter" && typeof props.onKeyPress === "function") {
      props.onKeyPress();
    }
  };

  const _handleKeyDown = (e) => {
    // Prevent default behavior of up and down arrow keys
    if (e.keyCode === 38 || e.keyCode === 40) {
      e.preventDefault();
    }
    if (props.type === "number") {
      if (e.key === "0" && props.value === "") {
        e.preventDefault();
      }
    }
    if (e.key === "." && props.not_decimal) {
      e.preventDefault();
    }
  };

  const hasAffix = Boolean(
    props.leadingAccessory || props.trailingAccessory,
  );

  const controlClass = `${props.error ? "e-border-error" : " e-border-input"} ${
    props.className
  } e-input ${props.disabled && "e-cursor-disabled"}  fw-400`;

  const control = (
    <input
      id={props.id}
      ref={props.ref}
      value={props.value}
      defaultValue={props.defaultValue}
      maxLength={props.maxLength}
      tabIndex={props.tabIndex}
      type={props.type}
      required={props.required}
      readOnly={props.readOnly}
      autoFocus={props.autoFocus}
      placeholder={props.placeholder}
      className={controlClass}
      onWheel={() => document.activeElement.blur()}
      onChange={_handleChange}
      onKeyDown={(e) => {
        _keyPress(e);
        _handleKeyDown(e);
      }}
      onClick={props.onClick}
      disabled={props.disabled}
    />
  );

  return (
    <div className="w-100">
      {props.label && (
        <label
          className={
            props.labelStyle
              ? props.labelStyle
              : "text-eerie-black  fw-400  fs-14 lh-18 pb-1"
          }
        >
          {props.label}
          {props.require && <span className="text-cg-red">*</span>}
          {props.info && (
            <span className="e-cursor-pointer">
              <CustomTooltip
                content={<span>{props.tooltip}</span>}
                placement="right bottom"
              >
                <Icon icon="info" size="12" className="ms-2" />
              </CustomTooltip>
            </span>
          )}
        </label>
      )}

      <div className="h-64">
        {hasAffix ? (
          <div className="position-relative w-100 e-input-control-row">
            {props.leadingAccessory}
            {control}
            {props.trailingAccessory}
          </div>
        ) : (
          control
        )}
        {props.afterControl}
        {props.error && (
          <p className="mb-0 fs-12 text-cg-red pt-1">
            {formatInputErrorMessage(props.error)}
          </p>
        )}
      </div>
    </div>
  );
};

Input.defaultProps = {
  onKeyPress: () => {},
  className: null,
  error: "",
  value: "",
  leadingAccessory: null,
  trailingAccessory: null,
  afterControl: null,
};

export default memo(Input);
